import ActionCable from 'actioncable';
import { getUrlParamsObject } from './browser';

const getActionCableUrl = () => {
  let appDomain = `${process.env.REACT_APP_API_URL.replace(/\/api/g, '')}`;
  const websocketStart = appDomain.includes('localhost') ? 'ws' : 'wss';
  if (appDomain.includes('localhost')) {
    appDomain = appDomain.replace(/http:\/\//, '');
  } else {
    appDomain = appDomain.replace(/https:\/\//, '');
  }
  return `${websocketStart}://${appDomain}/cable`;
};

// Consumer ActionCable partagé par tous les channels (EditorsChannel PDF,
// EditorCollabChannel...) : une seule connexion WebSocket pour l'application.
let consumer = null;

export const getCableConsumer = () => {
  if (consumer) return consumer;

  const jwt = getUrlParamsObject().jwt || window.localStorage.getItem('jwt');
  if (!jwt) return null;

  // Le JWT transite dans Sec-WebSocket-Protocol (cf. connection.rb côté back)
  ActionCable.INTERNAL.protocols.push(jwt);
  consumer = ActionCable.createConsumer(getActionCableUrl());
  return consumer;
};

export const disconnectCableConsumer = () => {
  if (!consumer) return;
  consumer.disconnect();
  consumer = null;
};
